import { SEARCH_PO_FAILURE, SEARCH_PO_REQUEST, SEARCH_PO_RESET, SEARCH_PO_SUCCESS } from "redux/actions/action-type"


const initialState = {
    isSearchLoading: false,
    isSearchSuccess: false,
    isSearchFail: false,
    searchPOResponse: {}
}

export const searchPOReducer = (state = initialState, { type, searchPOResponse }) => {
    switch (type) {
        case SEARCH_PO_REQUEST:
            return {
                ...state,
                isSearchLoading: true,
                isSearchSuccess: false,
                isSearchFail: false
            }
        case SEARCH_PO_SUCCESS:
            return {
                ...state,
                searchPOResponse: searchPOResponse,
                isSearchLoading: false,
                isSearchSuccess: true,
                isSearchFail: false
            }
        case SEARCH_PO_FAILURE:
            return {
                ...state,
                searchPOResponse: searchPOResponse,
                isSearchLoading: false,
                isSearchSuccess: false,
                isSearchFail: true
            }
        case SEARCH_PO_RESET:
            return {
                ...initialState
            }
        default:
            return {
                ...state
            }
    }
}